/**
 * The one promise owners asked for on the first onboarding call. Fixed copy, reused by the turn-on
 * dialog, the rules explainer and the How BTB blocks work guide so the wording cannot drift. The tool keys on
 * the title, not on who made a block: reconcile adopts any "Auto - BTB" block it finds, so the copy
 * says so. Each sentence maps to code (see UntouchedNote.test.tsx).
 */
export const UNTOUCHED_SENTENCES = [
  'This tool only changes blocks titled "Auto - BTB", the title it gives its own.',
  "Blocks with any other title, appointments and shift times are never touched.",
  "If someone renames one of our blocks, we stop managing it and leave it to them.",
] as const;

export function UntouchedNote() {
  return (
    <p role="note" className="rounded-md border border-hs-border bg-hs-surface-alt px-3 py-2 text-[13px] leading-5 text-hs-text-muted">
      <span className="font-semibold text-hs-text">Never touched: </span>{UNTOUCHED_SENTENCES.join(" ")}
    </p>
  );
}
